import { getTranslation } from '@/hooks/useTranslation';

const title = getTranslation('nav.routes.tools.historyTitle') || 'Tool history';

const ToolsHistoryRouteNavigationOptions = {
  title,
  headerTitle: () => null,
  headerBackVisible: true,
};

export default ToolsHistoryRouteNavigationOptions;
